import { Brand, I18NText, Position, State } from 'src/types'
import { genCatcherMittColorCells } from 'src/features/generatePdf/helper/catcherMitt'
import { genFirstMittColorCells } from 'src/features/generatePdf/helper/firstMitt'
import { genGloveColorCells } from 'src/features/generatePdf/helper/glove'

export const genColorCellsByPosition = (
  position: Position,
  state: State,
  brand: Brand,
  t: I18NText
): {
  head: string
  label: string
  color: string
  value: string
  partsKey: string
}[] => {
  switch (position) {
    case 'catcher':
      return genCatcherMittColorCells(state, brand, t)
    case 'first':
      return genFirstMittColorCells(state, brand, t)
    default:
      return genGloveColorCells(state, brand, position, t)
  }
}
